module.exports = __webpack_public_path__ + "img/aa4.aa1d78f2.jpg";